<template>
  <div v-if="techProviders.length" class="pos-relative" style="padding-top:50px;padding-bottom:80px;">
    <h2 class="text-center padding-b-20 k-page">You May Also Be Interested In</h2>
    <Row :gutter="20">
      <i-col :xs="24" :sm="12" :md="12" :xl="8" v-for="(company, idx) in techProviders" :key="idx" style="margin-bottom:20px">
        <CompanyCard
        :company="company"
        :marked="company.is_bookmarked"/>
      </i-col>
    </Row>
    <Spin fix v-if="isLoading"></Spin>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchCompaniesByCategory } from '@/services/companies'
import CompanyCard from './CompanyCard'

export default {
  props: {
    categoryId: {
      type: Number,
      default: null,
      require: true
    },
    companyId: {
      type: Number,
      default: null
    }
  },

  components: {
    CompanyCard
  },

  data () {
    return {
      isLoading: false,
      techProviders: []
    }
  },

  mounted () {
    this.getTechProvidersByCategory()
  },

  methods: {
    getTechProvidersByCategory () {
      fetchCompaniesByCategory(this.categoryId).then(res => {
        if (res.data && res.data.results) {
          const i = res.data.results.map(item => item.id).indexOf(this.companyId)
          res.data.results.splice(i, 1)
          this.techProviders = res.data.results.slice(0, 6)
        } else {
          this.techProviders = []
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch companies by category: ', err)
        this.isLoading = false
      })
    }
  },

  computed: {
    ...mapGetters(
      {
        getFilteredTechProviders: 'techProviders/getFilteredTechProviders'
      }
    )
  }
}
</script>
